import moment from 'moment'

export const SUNDAY = 0
export const MONDAY = 1
export const TUESDAY = 2
export const WEDNESDAY = 3
export const THURSDAY = 4
export const FRIDAY = 5
export const SATURDAY = 6

export function getDayOfWeekAtLeastOneWeekAway(dayOfWeek: number): moment.Moment {
  const day = moment().add(1, 'week')

  const initialDOW = day.day()
  // Use positive modulo to ensure we always move forward
  const diff = ((dayOfWeek - initialDOW) % 7 + 7) % 7
  day.add(diff, 'days')

  return day
}
